// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  flex: 1 1 auto;
  background: var(--bg);
}`, "",{"version":3,"sources":["webpack://./src/shared/overlay-side-panel/components/overlay-side-panel-content/overlay-side-panel-content.component.ts"],"names":[],"mappings":"AACM;EACE,cAAA;EACA,qBAAA;AAAR","sourcesContent":["\n      :host {\n        flex: 1 1 auto;\n        background: var(--bg);\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
